import { random } from "lodash"


export const GetValueGrade_Score = (val) => {
    const vg = parseInt((val >=0 && val <= 39) ? 3 : val <= 69 ? 2 : val <= 100 ? 1 : 0)
    return vg
}

export const GetAge_AdminBand = (val) => {
    const convVal = Number(val)
    if (convVal >=18 && convVal<=24){
        return 0
    } else if(convVal >=25 && convVal<=34){
        return 1
    }else if(convVal >=35 && convVal<=44){
        return 2
    }else if(convVal >=45 && convVal<=54){
        return 3
    }else if(convVal >=55 && convVal<=64){
        return 4
    }else if(convVal >=65 && convVal<=74){
        return 5
    }else if(convVal >=75 ){
        return 6
    } else {
        return -1
    }
}

    
    export const GetTransform = (fnc, val) => {
        if(fnc ==='SCORE TO VALUE GRADE'){
            return GetValueGrade_Score(val) 
         } else if (fnc ==='AGE ADMIN BANDS'){
            return GetAge_AdminBand(val) 
         }  else {
            return val
        }
    }